module.exports = __webpack_public_path__ + "static/media/middle-middle-4.34449869.png";